export default __webpack_public_path__ + "static/media/react_logo.92175378.svg";